import { useEffect } from "react";
import { useParams } from "react-router-dom";

import { AppsApi } from "src/service/apps";
import { authModel } from "src/store/authModel";
import { appsModel } from "src/store/appsModel";

export function useAppIdMiddleware() {
    const { id } = useParams();

    useEffect(() => {
        const appId = Number(id);
        const {accessToken} = authModel.getState();
        const { loading } = appsModel.getState();
        if (accessToken && appId && !loading?.getAppById) {
            AppsApi.getAppById(appId)
        }
    }, [id])
}